import gql from 'graphql-tag'

export const WHATS_ON_QUERY = gql`
  query WhatsOnCentre(
    $centreId: String!
    $durationFromNow: String!
    $timeZone: String!
  ) {
    whatsOnCentre(
      centreId: $centreId
      durationFromNow: $durationFromNow
      timeZone: $timeZone
    ) {
      __typename
      ... on CFEvent {
        title
        occurrencesCollection {
          items {
            startAt
            endAt
          }
        }
        slug
        topicsCollection {
          items {
            title
          }
        }
        experiencesCollection {
          items {
            title
          }
        }
        shortDescription
        ...CFEventHappeningsImage
        physicalAddress
        hosted
        level
        priceDescription
        callsToActionCollection {
          items {
            category
            address
          }
        }
        storesCollection {
          items {
            title
            centre {
              sys {
                id
              }
            }
          }
        }
        sys {
          id
        }
        analyticsMetadata {
          correlationId
          title
          promotion {
            creative
          }
        }
      }
      ... on CFOffer {
        title
        startAt
        hideAt
        showAt
        endAt
        slug
        topicsCollection {
          items {
            title
          }
        }
        experiencesCollection {
          items {
            title
          }
        }
        ...CFOfferHappeningsImage
        storesCollection {
          items {
            title
            centre {
              sys {
                id
              }
            }
          }
        }
        sys {
          id
        }
        analyticsMetadata {
          correlationId
          title
          promotion {
            creative
          }
        }
      }
    }
  }

  fragment CFEventHappeningsImage on CFEvent {
    heroImageSet {
      master {
        title
        description
        url
      }
      square {
        title
        description
        url
      }
      description
    }
  }

  fragment CFOfferHappeningsImage on CFOffer {
    heroImageSet {
      master {
        title
        description
        url
      }
      square {
        title
        description
        url
      }
      description
    }
  }
`
